import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import axios from "axios"; // Import axios
import "../Faq/faq.css";
import { useNavigate } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";

const FaqPage = () => {
  const [faqData, setFaqData] = useState([]);
  const [isMarketFrozen, setIsMarketFrozen] = useState(false);
  const [freezeMessage, setFreezeMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [totalDeposit, setTotalDeposit] = useState(0);

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: email,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setEmail(""); // Clear input
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(error);
    }
  };

  const handleEmailClick = () => {
    const email = "contact@toptennis.io";
    const subject = "";
    const body = "";
    const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(url, "_blank");
  };

  const showFreezeBanner = () => {
    return (
      <div className="freeze-banner">
        <p>{freezeMessage}</p>
      </div>
    );
  };
  const fetchMarketStatus = async () => {
    setIsLoading(true); // Start loader
    try {
      const Token = localStorage.getItem("user_token");
      const response = await axios.get(
        "https://toptennis.io/api/public/market-status",
        {
          // headers: { Authorization: `Bearer ${Token}` },
        }
      );

      // Extract values from the API response
      const { isFrozen, bannerText } = response.data;

      // Update state with both values
      setIsMarketFrozen(isFrozen);
      setFreezeMessage(bannerText || ""); // Ensure it's not undefined
      await fetchUserValues();
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching market status:", error);
    } finally {
      setIsLoading(false); // Ensure loader stops after API response
    }
  };

  // const fetchMarketStatus = async () => {
  //   try {
  //     const Token = localStorage.getItem("user_token");
  //     const response = await axios.get(
  //       "https://toptennis.io/api/users/market-status",
  //       {
  //         headers: { Authorization: `Bearer ${Token}` },
  //       }
  //     );

  //     // Extract values from the API response
  //     const { isFrozen, bannerText } = response.data;

  //     // Update state with both values
  //     setIsMarketFrozen(isFrozen);
  //     setFreezeMessage(bannerText || ""); // Ensure it's not undefined
  // await fetchUserValues();

  //   } catch (error) {
  //     console.error("Error fetching market status:", error);
  //   }
  // };
  useEffect(() => {
    fetchMarketStatus();
    showFreezeBanner();
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const token = localStorage.getItem("user_token");
        let response;
        if (token) {
          response = await axios.get("https://toptennis.io/api/public/faqs", {
            // headers: { Authorization: `Bearer ${token}` },
          });
        } else {
          // No token, fetch without Authorization header
          response = await axios.get("https://toptennis.io/api/public/faqs");
        }
        setFaqData(response.data); // Set the FAQ data
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };
    fetchFAQs();
  }, []);
  const [show1, setShow1] = useState(false);
  const [differenceValue, setDifferenceValue] = useState(0);
  const [playerval, setplayerval] = useState(0);
  const [inPlayValue, setInPlayValue] = useState(0);
  const [credits, setCredits] = useState(0);
  const [userName, setUserName] = useState("");
  const [totalSpent, setTotalSpent] = useState(0);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const fetchUserValues = async () => {
    const Token = localStorage.getItem("user_token");

    if (Token) {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      try {
        // Fetch user in-play values
        const response = await axios.get(
          `https://toptennis.io/api/users/user/in-play-value/${userId}`,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );

        const {
          name,
          credits,
          grand_total_value,
          player_value_sum,
          differenceValue,
          latest_inc,
          totalDeposit,
        } = response.data;

        setUserName(name);
        setCredits(credits);
        setInPlayValue(grand_total_value);
        setTotalSpent(player_value_sum);
        setDifferenceValue(differenceValue);
        setplayerval(latest_inc);
        setTotalDeposit(totalDeposit || 0);
      } catch (error) {
        console.error("Error fetching in-play values:", error);
      }
    }
  };

  useEffect(() => {
    fetchUserValues();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user_token");
    localStorage.removeItem("fullName");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_isfrozen");
    localStorage.removeItem("email");
    console.log("User logged out successfully.");
    navigate("/");
  };

  const isLoggedIn = !!localStorage.getItem("user_token");

  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      {isLoggedIn ? (
        <div className="mainbody">
          <div className="container">
            <div className="freeze-banner">
              <p>{freezeMessage}</p>
            </div>
            <div className="faqsection">
              <div className="user-info">
                <button
                  variant="light"
                  className="d-md-none menu-btn"
                  onClick={handleShow1}
                >
                  ☰ {/* Hamburger Icon */}
                </button>
                <div className="left-section1 d-flex1">
                  <span className="welcome-text">Welcome, {userName}</span>
                  <div className="top-navigation d-none d-md-flex">
                    <span
                      className="nav-item"
                      onClick={() => navigate("/home")}
                    >
                      Home
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => navigate("/profile")}
                    >
                      Profile
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => navigate("/myteam")}
                    >
                      My Team
                    </span>
                    <span
                      className="nav-item active"
                      onClick={() => navigate("/faq")}
                    >
                      FAQs
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => navigate("/news")}
                    >
                      News
                    </span>
                    <span className="nav-item" onClick={handleLogout}>
                      Logout
                    </span>
                  </div>
                </div>

                {/* Mobile Navigation */}
                <Offcanvas show={show1} onHide={handleClose1} placement="start">
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <div className="mobile-nav">
                      <span
                        className="nav-item"
                        onClick={() => {
                          navigate("/home");
                          handleClose1();
                        }}
                      >
                        Home
                      </span>
                      <span
                        className="nav-item"
                        onClick={() => {
                          navigate("/profile");
                          handleClose1();
                        }}
                      >
                        Profile
                      </span>
                      <span
                        className="nav-item"
                        onClick={() => {
                          navigate("/myteam");
                          handleClose1();
                        }}
                      >
                        My Team
                      </span>
                      <span
                        className="nav-item active"
                        onClick={() => {
                          navigate("/faq");
                          handleClose1();
                        }}
                      >
                        FAQs
                      </span>
                      <span
                        className="nav-item"
                        onClick={() => navigate("/news")}
                      >
                        News
                      </span>
                      <span className="nav-item" onClick={handleLogout}>
                        Logout
                      </span>
                    </div>
                  </Offcanvas.Body>
                </Offcanvas>

                {/* Credit Box */}
                <div className="right-section1">
                  <div className="credit-box-container">
                    <button
                      className="topup-button"
                      onClick={() => {
                        navigate("/topup");
                      }}
                    >
                      Top-up
                    </button>
                    <div className="credit-box">
                      <p className="p">
                        Credit available: <span>{credits?.toFixed(2)}</span>
                      </p>
                      <p className="p">
                        In-play: <span>{inPlayValue.toFixed(2)}</span>
                      </p>
                      <p className="p">
                        Current Team P/L:&nbsp;
                        <span
                          style={{
                            color:
                              Number(differenceValue) > 0
                                ? "green"
                                : Number(differenceValue) < 0
                                ? "red"
                                : "black",
                          }}
                        >
                          {differenceValue
                            ? Number(differenceValue) > 0
                              ? `+${Number(differenceValue).toFixed(2)}`
                              : Number(differenceValue).toFixed(2)
                            : "0.00"}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* FAQ Section with Scrolling */}
              <div
                className="faq-container"
                style={{
                  // maxHeight: "500px",
                  overflowY: "auto",
                  padding: "10px",
                  marginBottom: "20px",
                }}
              >
                <Accordion defaultActiveKey="0" style={{ padding: "10px 0px" }}>
                  {faqData.map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={faq._id}>
                      <Accordion.Header
                        style={{ color: "black", whiteSpace: "pre-wrap" }}
                      >
                        {faq.question}
                      </Accordion.Header>
                      <Accordion.Body
                        style={{
                          color: "gray",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        <div
                          style={{
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                          }}
                          dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="faq-container cont1"
          style={{
            // maxHeight: "550px",
            overflowY: "auto",
            paddingTop: "15px",
            marginBottom: "20px",
          }}
        >
          <div className="freeze-banner">
            <p>{freezeMessage}</p>
          </div>
          <Accordion defaultActiveKey="0" style={{ padding: "10px 0px" }}>
            {faqData.map((faq, index) => (
              <Accordion.Item eventKey={index.toString()} key={faq._id}>
                <Accordion.Header
                  style={{ color: "black", whiteSpace: "pre-wrap" }}
                >
                  {faq.question}
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    color: "gray",
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <div
                    style={{
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      )}
      <div className="cont1">
        <div className="card-footer3">
          <div className="card-footer-topup">
            <div className="footer">
              <div className="footer-firstline">
                <div className="footer-sub">
                  <h4>Keep in touch</h4>
                  <h5>Join our newsletter. We promise not to spam!</h5>
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="footer-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button className="subscribe-btn" onClick={handleSubscribe}>
                    Subscribe
                  </button>
                  {message && (
                    <p style={{ marginTop: "10px", marginLeft: "5px" }}>
                      {message}
                    </p>
                  )}
                </div>

                <div className="footer-sub1">
                  <h4>Quick links</h4>
                  {localStorage.getItem("user_token") ? (
                    <>
                      <a href="/home" className="footer-link">
                        Home
                      </a>
                      <a href="/profile" className="footer-link">
                        Profile
                      </a>
                      <a href="/myteam" className="footer-link">
                        My Team
                      </a>
                    </>
                  ) : null}
                  <a href="/news" className="footer-link">
                    News
                  </a>
                  <a href="/faq" className="footer-link">
                    FAQs
                  </a>
                </div>

                <div className="footer-sub1 secondicon">
                  <h4>Socials</h4>
                  <div className="social-icons">
                    <a
                      href="https://www.facebook.com/toptennisio/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/toptennisuk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>

                  <div className="fl1">
                    <a
                      href="/terms"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      T&Cs
                    </a>
                    <a
                      href="/privacy"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                    <span className="footer-link">
                      Email: contact@toptennis.io
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqPage;
